import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
// import { CommonService } from 'src/app/core/services/common.service';

@Component({
  standalone: false,
  selector: 'app-no-organization',
  templateUrl: './no-organization.component.html',
  styleUrls: ['./no-organization.component.scss']
})
export class NoOrganizationComponent implements OnInit {

  constructor(
    // private commonService: CommonService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
  }

  closeModel() {
    // this.commonService.logOut()
    this.activeModal.close('Cross click');
  }
}
